// ANCHOR Head of modal
export const HEAD = 'Are you sure?';
